import React from "react";

// Informasi shift yang sedang berjalan untuk layar pasien (hanya nama shift).
const ShiftInformation = ({ shift }) => {
  if (!shift?.name) return null;

  return (
    <div className="show-queue-shift-info">
      <p className="show-queue-shift-name">Shift {shift.name}</p>
    </div>
  );
};

export default ShiftInformation;
